{"statusPath":"/api/status/","downloadPath":"/api/download/","pollInterval":750,"maxWait":20000}